import { Listbox } from '@headlessui/react';
import { ChevronsUpDown, Check } from "lucide-react";
import { Platform } from "@/types";
import { PLATFORM_OPTIONS } from "@/constants/platforms";
import { cn } from "@/lib/utils";

interface Props {
  value: Platform;
  onChange: (value: Platform) => void;
}

export function PlatformSelect({ value, onChange }: Props) {
  const current = PLATFORM_OPTIONS.find((option) => option.value === value);

  return (
    <Listbox value={value} onChange={onChange}>
      <div className="relative w-36">
        <Listbox.Button className="flex w-full items-center justify-between rounded-2xl border border-white/10 bg-white/5 px-3 py-2 text-sm text-white">
          {current && (
            <span className="flex items-center gap-2">
              <span
                className="flex h-7 w-7 items-center justify-center rounded-full"
                style={{ backgroundColor: current.color }}
              >
                <img
                  src={current.logo}
                  alt={current.label}
                  width={18}
                  height={18}
                />
              </span>
              {current.label}
            </span>
          )}
          <ChevronsUpDown className="h-4 w-4 text-white/60" />
        </Listbox.Button>
        <Listbox.Options className="absolute z-10 mt-2 w-full space-y-1 rounded-2xl border border-white/10 bg-zinc-900 p-2 text-sm">
          {PLATFORM_OPTIONS.map((option) => (
            <Listbox.Option key={option.value} value={option.value}>
              {({ selected }) => (
                <div
                  className={cn(
                    "flex cursor-pointer items-center justify-between rounded-xl px-3 py-2",
                    selected ? "bg-white/10" : "text-white/70"
                  )}
                >
                  <div className="flex items-center gap-2">
                    <span
                      className="flex h-7 w-7 items-center justify-center rounded-full"
                      style={{ backgroundColor: option.color }}
                    >
                      <img src={option.logo} alt={option.label} width={18} height={18} />
                    </span>
                    {option.label}
                  </div>
                  {selected && <Check className="h-4 w-4" />}
                </div>
              )}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </div>
    </Listbox>
  );
}
